import { useEditor, EditorContent } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import Image from '@tiptap/extension-image'
import Link from '@tiptap/extension-link'
import Placeholder from '@tiptap/extension-placeholder'
import TextAlign from '@tiptap/extension-text-align'
import FontSize from '@tiptap/extension-font-size'
import { TextStyle } from '@tiptap/extension-text-style'
import { useLoginStore } from '../../store/zustend';
import { ToastContainer, toast, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "../../toastify/config";

import {
    Box,
    TextField,
    Button,
    Typography
} from '@mui/material'

import { useState } from 'react'
import ToolBarEditor from './ToolBarEditor'
import apiSafibc from '../../axios/axios'

export default function AgregarArticulo() {
    const [titulo, setTitulo] = useState('')
    const [slug, setSlug] = useState('')
    const [contenido, setContenido] = useState('')
    const { loginStore } = useLoginStore()

    const editor = useEditor({
        extensions: [
            StarterKit,
            TextStyle,
            FontSize,
            Image,
            Link.configure({ openOnClick: false }),
            Placeholder.configure({
                placeholder: 'Escribe aquí...',
                emptyEditorClass: 'is-editor-empty',
            }),
            TextAlign.configure({
                types: ['heading', 'paragraph']
            })
        ],
        content: '',
        onUpdate: ({ editor }) => {
            setContenido(editor.getHTML())
        }
    })

    // 🔥 generar slug automático
    const generarSlug = (texto) => {
        return texto
            .toLowerCase()
            .trim()
            .replace(/[^a-z0-9\s-]/g, '')
            .replace(/\s+/g, '-')
    }

    const handleTituloChange = (e) => {
        const value = e.target.value
        setTitulo(value)
        setSlug(generarSlug(value))
    }

    // 💾 guardar artículo
    const guardarArticulo = async () => {
        try {

            const articulo = {
                titulo,
                slug,
                contenido
            }

            const res = await apiSafibc.post('/blog/guardar-articulo', articulo, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`,
                    'Accept': 'application/x-www-form-urlencoded',
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            })



            //console.log('Guardado:', data)
        } catch (error) {
            let msg_error = ''
            if (error.response) {
                if (error.response.data.mensaje) {
                    msg_error = error.response.data.mensaje
                } else {
                    msg_error = 'Ocurrió un error al generar articulo, favor de volver a cargar!'
                }
            }
            //mensaje de toastify
            toast.error(msg_error, toast_config)
        }
    }

    if (!editor) return null

    return (
        <div className='container my-5'>
            <div className='row'>
                <div className='col-md-12'>
                    <div className='card shadow'>
                        <div className='card-body'>
                            <Box sx={{ maxWidth: '900px', mx: 'auto', mt: 4 }}>

                                <Typography variant="h4" mb={2}>
                                    Crear artículo
                                </Typography>

                                {/* 📝 TITULO */}
                                <TextField
                                    fullWidth
                                    label="Título"
                                    value={titulo}
                                    onChange={handleTituloChange}
                                    sx={{ mb: 2 }}
                                />

                                {/* 🔗 SLUG */}
                                <TextField
                                    fullWidth
                                    label="Slug"
                                    value={slug}
                                    onChange={(e) => setSlug(e.target.value)}
                                    sx={{ mb: 3 }}
                                />

                                {/* 🧩 TOOLBAR */}
                                <ToolBarEditor editor={editor} />

                                {/* ✍️ EDITOR */}
                                <Box
                                    sx={{
                                        border: '1px solid #ccc',
                                        borderRadius: 2,
                                        p: 2,
                                        minHeight: '300px',
                                        outline: 'none',

                                        '&:focus': {
                                            outline: 'none'
                                        },

                                        '&:focus-within': {
                                            outline: 'none',
                                            border: '1px solid #ccc', // 👈 mismo borde, no cambia
                                            boxShadow: 'none'
                                        }
                                    }}
                                >
                                    <EditorContent editor={editor} />
                                </Box>

                                {/* 💾 BOTON */}
                                <Button
                                    variant="contained"
                                    onClick={guardarArticulo}
                                    sx={{ mt: 3 }}
                                >
                                    Guardar artículo
                                </Button>
                            </Box>
                        </div>
                    </div>

                </div>

            </div>

            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />



        </div>

    )
}